'use client'

import { FormDatePicker, FormDatePickerProps } from './FormDatePicker'
import React, { ReactElement, useState } from 'react'

interface Props extends Omit<FormDatePickerProps, 'onChange'> {
    required?: boolean
    onChange?: (date: Date | null) => void
}

export const FormDatePickerWithHTMLInput = ({
    id,
    defaultDate,
    required = false,
    onChange,
    ...rest
}: Props): ReactElement => {
    const [date, setDate] = useState<Date | null>(defaultDate ?? null)

    return (
        <>
            <FormDatePicker
                {...rest}
                defaultDate={date}
                onChange={(date: Date | null) => {
                    setDate(date)
                    if (id) {
                        const field = document?.getElementById(id)
                        //@ts-ignore
                        if (field) field.value = date
                    }
                    onChange?.(date)
                }}
                id={`${id}-fake`}
                required={required}
            />
            <input type="hidden" id={id} name={id} defaultValue={date ? String(date) : undefined} required={required} />
        </>
    )
}
